import { API, graphqlOperation } from "aws-amplify";
import { createProduct_info, deleteProduct_info, updateProduct_info } from "../../graphql/mutations";
import { getProduct_info, listProduct_infos } from "../../graphql/queries";

export const CreateProduct = async (postParams) => {
  try {
    const result = await API.graphql(
      graphqlOperation(createProduct_info, postParams)
    );
    return result.data.createProduct_info;
  } catch (res) {
    const { errors } = res;
    console.error(errors);
  }
};

export const GetProducts = async () => {
  try {
    const result = await API.graphql(graphqlOperation(listProduct_infos));
    const data = result.data.listProduct_infos;
    return data;
  } catch (res) {
    const { errors } = res;
    console.error(errors);
  }
};

export const GetProductByID = async (id) => {
  try {
    const result = await API.graphql(graphqlOperation(getProduct_info, {product_id: id}));
    const data = result.data.getProduct_info;
    return data;
  } catch (res) {
    const { errors } = res;
    console.error(errors);
  }
};

export const DeleteProduct = async (params) => {
  try {
    const result = await API.graphql(graphqlOperation(deleteProduct_info, params));
    return result.data.deleteProduct_info;
  } catch (res) {
    const { errors } = res;
    console.error(errors);
  }
};

export const UpdateProduct = async (postParams) => {
  try {
    const result = await API.graphql(graphqlOperation(updateProduct_info, postParams));
    return result.data.updateProduct_info;
  } catch (res) {
    const { errors } = res;
    console.error(errors);
  }
};